@if (wrapInListItem()) {
  @for (item of counter(count()); track $index) {
    <li class="auction-card-skeleton__list-item">
      <div class="auction-card-skeleton">
        <div class="auction-card-skeleton__media">
          <div class="auction-card-skeleton__media-shimmer">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                height: '100%',
                'border-radius': '0',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
          <div class="auction-card-skeleton__countdown">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '7.5rem',
                height: '1.75em',
                'border-radius': '1.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>

        <div class="auction-card-skeleton__body">
          <ngx-skeleton-loader
            count="1"
            class="auction-card-skeleton__title"
            [theme]="{
              width: '82%',
              height: '1.125em',
              'border-radius': '0.25rem',
              margin: '0',
            }"></ngx-skeleton-loader>

          <div class="auction-card-skeleton__divider"></div>

          <div class="auction-card-skeleton__footer">
            <div class="auction-card-skeleton__price">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  width: '4.5rem',
                  height: '0.875em',
                  'border-radius': '0.25rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  width: '5.5rem',
                  height: '1.25em',
                  'border-radius': '0.25rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
            </div>
            <ngx-skeleton-loader
              count="1"
              class="auction-card-skeleton__cta"
              [theme]="{
                width: '5.5rem',
                height: '2.375em',
                'border-radius': '0.625rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </li>
  }
} @else {
  <div [ngClass]="containerClasses()">
    @for (item of counter(count()); track $index) {
      <div class="auction-card-skeleton">
        <div class="auction-card-skeleton__media">
          <div class="auction-card-skeleton__media-shimmer">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                height: '100%',
                'border-radius': '0',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
          <div class="auction-card-skeleton__countdown">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '7.5rem',
                height: '1.75em',
                'border-radius': '1.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>

        <div class="auction-card-skeleton__body">
          <ngx-skeleton-loader
            count="1"
            class="auction-card-skeleton__title"
            [theme]="{
              width: '82%',
              height: '1.125em',
              'border-radius': '0.25rem',
              margin: '0',
            }"></ngx-skeleton-loader>

          <div class="auction-card-skeleton__divider"></div>

          <div class="auction-card-skeleton__footer">
            <div class="auction-card-skeleton__price">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  width: '4.5rem',
                  height: '0.875em',
                  'border-radius': '0.25rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  width: '5.5rem',
                  height: '1.25em',
                  'border-radius': '0.25rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
            </div>
            <ngx-skeleton-loader
              count="1"
              class="auction-card-skeleton__cta"
              [theme]="{
                width: '5.5rem',
                height: '2.375em',
                'border-radius': '0.625rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    }
  </div>
}
